import React, { Fragment, useEffect, useState } from "react";
import { ArrowRightOutlined } from "@ant-design/icons";
import CategoryItem from "./items/CategoryItem";
import { images } from "../assets";
import Heading from "./Heading";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import { Autoplay, Grid } from "swiper";
import APIService from "../services/APIService";

const CategoryHome = () => {
  const [swiper, setSwiper] = useState(null);
  const [swiperM, setSwiperM] = useState(null);
  const [listCategory, setListCategory] = useState(["", "", "", "", ""]);

  async function getListCategory() {
    const RESULT = await APIService.getListCategory();
    if (RESULT) {
      setListCategory(RESULT);
    }
  }

  useEffect(() => {
    getListCategory();
  }, []);

  const handleNext = () => {
    swiper.slideNext();
    swiperM.slideNext();
  };
  const handlePrev = () => {
    swiper.slidePrev();
    swiperM.slidePrev();
  };

  return listCategory.length ? (
    <Fragment>
      <Swiper
        modules={[Grid, Autoplay]}
        grid={{
          rows: 1,
          fill: 'row'
        }}
        breakpoints={{
          320: {
            width: 320,
            grid: {
              rows: 2,
            },
            slidesPerView: 2.2,
          },
          640: {
            width: 640,
            grid: {
              rows: 2,
            },
            slidesPerView: 2.2,
          },
          769: {
            width: 769,
            slidesPerView: 3.3,
          },
          1024: {
            width: 1024,
            slidesPerView: 4.4,
          },
        }}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        className="mySwiper"
        pagination={{ clickable: true }}
        scrollbar={{ draggable: true }}
        onSwiper={setSwiper}
      >
        <Heading
        slot="container-start"
          linkTo="category-list"
          title="Danh mục sản phẩm"
          handlePrev={handlePrev}
          handleNext={handleNext}
        />
        {listCategory.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="lg:my-4 my-2  mr-3">
              <CategoryItem data={item}></CategoryItem>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </Fragment>
  ) : (
    <></>
  );
};

export default CategoryHome;
